import React from 'react';

const About = () => {
  return (
    <div>
      <h1>About Our Restaurant</h1>
      <p className="lead">
        Welcome to Your Restaurant Name, where we serve delicious and mouthwatering dishes made with the finest ingredients. Our goal is to provide a memorable dining experience for our customers, combining great food, friendly service, and a cozy atmosphere.
      </p>
      <p>
        At Your Restaurant Name, we take pride in our diverse menu that caters to various tastes and preferences. Whether you're a fan of traditional classics or
      </p>
    </div>
  );
};

export default About;